import { connect } from 'react-redux';
import { withOptimizely } from '@optimizely/react-sdk';

import { SignupForm } from 'components/SignupForm';
import {
  submitCreateAccountForImportForm,
  showRequestResetPassword,
} from 'client/user';

const mapDispatchToProps = (dispatch, { submitCallback, optimizely }) => ({
  onSubmit: (data, setError) =>
    dispatch(
      submitCreateAccountForImportForm(
        data,
        submitCallback,
        setError,
        optimizely.user.id // remove after age gating experiment
      )
    ),
  loginUrl: '/switch/login',
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = () => ({
  isImporting: true,
});

// @TODO remove withOptimizely after age gating experiment
export default withOptimizely(
  connect(mapStateToProps, mapDispatchToProps)(SignupForm)
);
